export default "__VITE_ASSET__CqnN5wbb__"